enum KnownHttpHeaders {
  MoboId = "MoboId",
  UnavailableResource = "x-resource-unavailable",
  RecordsCount = "x-bsi-recordscount",
}

export default KnownHttpHeaders;
